import { cleanHTMLForComparison } from "routes/schedule/compare/ifNotSameText"

export function getComparisonNormalizeString(...items) {
    return (
        items.find((item) => typeof item?.$comparisonNormalizeString === "function")?.$comparisonNormalizeString ??
        cleanHTMLForComparison
    )
}

export function getComparisonNormalizeHtml(...items) {
    return items.find((item) => typeof item?.$comparisonNormalizeHtml === "function")?.$comparisonNormalizeHtml
}
